<template>
    <div class="breadcrumb-container">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index"
                :to="getBreadcrumbTo(item)"
                :class="{ 'breadcrumb-current': isLastItem(index), 'breadcrumb-plain': !item.path }"
                @click.native="handleBreadcrumbClick(item, index)">
                {{ item.name }}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
export default {
    name: 'BreadcrumbNav',
    props: {
        reportTypeMap: {
            type: Object,
            default: () => ({
                '0': '帖子举报',
                '1': '帖子申诉',
                '2': '圈子投诉',
                '3': '圈主/管理员举报',
                '4': '用户举报',
                '5': '评论举报',
                '6': '回复评论举报',
                '7': '艺局举报'
            })
        },
        rankTypeMap: {
            type: Object,
            default: () => ({})
        },
        routeBreadcrumbMap: {
            type: Object,
            required: true
        }
    },
    computed: {
        breadcrumbList() {
            const path = this.normalizePath(this.$route.path)
            const dynamicBreadcrumb = this.getDynamicBreadcrumb(path)
            if (dynamicBreadcrumb) {
                return dynamicBreadcrumb
            }

            return this.routeBreadcrumbMap[path] || this.getFallbackBreadcrumb(path)
        }
    },
    methods: {
        normalizePath(path) {
            if (!path || path === '/') return '/home'
            return path.replace(/\/$/, '')
        },
        getDynamicBreadcrumb(path) {
            if (path.startsWith('/cardReport/')) {
                const typeId = this.$route.params.typeId || path.split('/').pop()
                return this.buildBreadcrumb([
                    { name: '举报管理' },
                    { path, name: this.reportTypeMap[typeId] || '举报详情' }
                ])
            }

            if (path.startsWith('/musterRanking/')) {
                const rankType = this.$route.params.url || path.split('/').pop()
                return this.buildBreadcrumb([
                    { name: '用户信息' },
                    { name: '排行列表' },
                    { path, name: this.rankTypeMap[rankType] || '排行榜' }
                ])
            }

            return null
        },
        getFallbackBreadcrumb(path) {
            const routeName = this.$route.meta && this.$route.meta.title
                ? this.$route.meta.title
                : this.$route.name || '当前页面'
            return this.buildBreadcrumb([{ path, name: routeName }])
        },
        buildBreadcrumb(items) {
            return [{ path: '/home', name: '首页' }, ...items]
        },
        isLastItem(index) {
            return index === this.breadcrumbList.length - 1
        },
        getBreadcrumbTo(item) {
            if (!item.path || this.normalizePath(item.path) === this.normalizePath(this.$route.path)) {
                return null
            }
            return item.path
        },
        handleBreadcrumbClick(item, index) {
            if (this.isLastItem(index)) {
                this.$emit('current-page-click', item.path)
                return false
            }
            return true
        }
    }
}
</script>

<style lang="scss" scoped>
.breadcrumb-container {
    flex: 1;
    margin: 0 20px;
    color: #666;

    ::v-deep .el-breadcrumb {
        font-size: 14px;
    }

    ::v-deep .el-breadcrumb__inner {
        color: #6b778c;
        font-weight: 400;

        &.is-link {
            color: #516173;
            font-weight: 400;

            &:hover {
                color: #1677ff;
            }
        }
    }

    ::v-deep .breadcrumb-current .el-breadcrumb__inner {
        color: #1f2d3d !important;
        font-weight: 600 !important;
        cursor: default;
    }

    ::v-deep .breadcrumb-plain {
        .el-breadcrumb__inner {
            cursor: default;
        }
    }
}
</style>
